export const ANALYTICS_FILTERS = {
    GRANULARITY: [
        { label: 'Half Hour', value: 'HALF_HOUR' },
        { label: 'Day', value: 'DAY' },
        { label: 'Month', value: 'MONTH' }
    ],

    PRICING_GRANULARITY: [
        { label: 'Half Hour', value: 'HALF_HOURLY' },
        { label: 'Daily', value: 'DAILY' },
        { label: 'Monthly', value: 'MONTHLY' }
    ],

    PRODUCT_TYPES: [
        { label: 'Notifications Messages', value: 0 },
        { label: 'Customer Support Messages', value: 2 }
    ],

    DIMENSIONS: [
        { label: 'Country', value: 'COUNTRY' },
        { label: 'Phone', value: 'PHONE' },
        { label: 'Pricing Category', value: 'PRICING_CATEGORY' },
        { label: 'Pricing Type', value: 'PRICING_TYPE' },
        { label: 'Tier', value: 'TIER' }
    ],

    METRIC_TYPES: [
        { label: 'Cost', value: 'COST' },
        { label: 'Volume', value: 'VOLUME' }
    ],

    PRICING_CATEGORIES: [
        { label: 'Authentication', value: 'AUTHENTICATION' },
        { label: 'Marketing', value: 'MARKETING' },
        { label: 'Utility', value: 'UTILITY' }
    ],

    PRICING_TYPES: [
        { label: 'Free Customer Service', value: 'FREE_CUSTOMER_SERVICE' },
        { label: 'Regular', value: 'REGULAR' }
    ],

    COUNTRY_CODES: [
        { label: 'All Countries', value: 'all', code: 'ALL' },
        { label: 'Afghanistan (AF)', value: 'AF', code: 'AF' },
        { label: 'Algeria (DZ)', value: 'DZ', code: 'DZ' },
        { label: 'Angola (AO)', value: 'AO', code: 'AO' },
        { label: 'Argentina (AR)', value: 'AR', code: 'AR' },
        { label: 'Australia (AU)', value: 'AU', code: 'AU' },
        { label: 'Austria (AT)', value: 'AT', code: 'AT' },
        { label: 'Bahrain (BH)', value: 'BH', code: 'BH' },
        { label: 'Bangladesh (BD)', value: 'BD', code: 'BD' },
        { label: 'Belgium (BE)', value: 'BE', code: 'BE' },
        { label: 'Brazil (BR)', value: 'BR', code: 'BR' },
        { label: 'Brunei (BN)', value: 'BN', code: 'BN' },
        { label: 'Cambodia (KH)', value: 'KH', code: 'KH' },
        { label: 'Canada (CA)', value: 'CA', code: 'CA' },
        { label: 'Chile (CL)', value: 'CL', code: 'CL' },
        { label: 'China (CN)', value: 'CN', code: 'CN' },
        { label: 'Colombia (CO)', value: 'CO', code: 'CO' },
        { label: 'Czech Republic (CZ)', value: 'CZ', code: 'CZ' },
        { label: 'Denmark (DK)', value: 'DK', code: 'DK' },
        { label: 'Egypt (EG)', value: 'EG', code: 'EG' },
        { label: 'Ethiopia (ET)', value: 'ET', code: 'ET' },
        { label: 'Finland (FI)', value: 'FI', code: 'FI' },
        { label: 'France (FR)', value: 'FR', code: 'FR' },
        { label: 'Germany (DE)', value: 'DE', code: 'DE' },
        { label: 'Ghana (GH)', value: 'GH', code: 'GH' },
        { label: 'Greece (GR)', value: 'GR', code: 'GR' },
        { label: 'Hong Kong (HK)', value: 'HK', code: 'HK' },
        { label: 'Hungary (HU)', value: 'HU', code: 'HU' },
        { label: 'India (IN)', value: 'IN', code: 'IN' },
        { label: 'Indonesia (ID)', value: 'ID', code: 'ID' },
        { label: 'Iran (IR)', value: 'IR', code: 'IR' },
        { label: 'Iraq (IQ)', value: 'IQ', code: 'IQ' },
        { label: 'Ireland (IE)', value: 'IE', code: 'IE' },
        { label: 'Italy (IT)', value: 'IT', code: 'IT' },
        { label: 'Japan (JP)', value: 'JP', code: 'JP' },
        { label: 'Jordan (JO)', value: 'JO', code: 'JO' },
        { label: 'Kenya (KE)', value: 'KE', code: 'KE' },
        { label: 'Kuwait (KW)', value: 'KW', code: 'KW' },
        { label: 'Lebanon (LB)', value: 'LB', code: 'LB' },
        { label: 'Malaysia (MY)', value: 'MY', code: 'MY' },
        { label: 'Mexico (MX)', value: 'MX', code: 'MX' },
        { label: 'Morocco (MA)', value: 'MA', code: 'MA' },
        { label: 'Nepal (NP)', value: 'NP', code: 'NP' },
        { label: 'Netherlands (NL)', value: 'NL', code: 'NL' },
        { label: 'New Zealand (NZ)', value: 'NZ', code: 'NZ' },
        { label: 'Nigeria (NG)', value: 'NG', code: 'NG' },
        { label: 'Norway (NO)', value: 'NO', code: 'NO' },
        { label: 'Oman (OM)', value: 'OM', code: 'OM' },
        { label: 'Pakistan (PK)', value: 'PK', code: 'PK' },
        { label: 'Peru (PE)', value: 'PE', code: 'PE' },
        { label: 'Philippines (PH)', value: 'PH', code: 'PH' },
        { label: 'Poland (PL)', value: 'PL', code: 'PL' },
        { label: 'Portugal (PT)', value: 'PT', code: 'PT' },
        { label: 'Qatar (QA)', value: 'QA', code: 'QA' },
        { label: 'Romania (RO)', value: 'RO', code: 'RO' },
        { label: 'Russia (RU)', value: 'RU', code: 'RU' },
        { label: 'Saudi Arabia (SA)', value: 'SA', code: 'SA' },
        { label: 'Singapore (SG)', value: 'SG', code: 'SG' },
        { label: 'South Africa (ZA)', value: 'ZA', code: 'ZA' },
        { label: 'South Korea (KR)', value: 'KR', code: 'KR' },
        { label: 'Spain (ES)', value: 'ES', code: 'ES' },
        { label: 'Sri Lanka (LK)', value: 'LK', code: 'LK' },
        { label: 'Sweden (SE)', value: 'SE', code: 'SE' },
        { label: 'Switzerland (CH)', value: 'CH', code: 'CH' },
        { label: 'Taiwan (TW)', value: 'TW', code: 'TW' },
        { label: 'Tanzania (TZ)', value: 'TZ', code: 'TZ' },
        { label: 'Thailand (TH)', value: 'TH', code: 'TH' },
        { label: 'Tunisia (TN)', value: 'TN', code: 'TN' },
        { label: 'Turkey (TR)', value: 'TR', code: 'TR' },
        { label: 'Uganda (UG)', value: 'UG', code: 'UG' },
        { label: 'Ukraine (UA)', value: 'UA', code: 'UA' },
        { label: 'United Arab Emirates (AE)', value: 'AE', code: 'AE' },
        { label: 'United Kingdom (GB)', value: 'GB', code: 'GB' },
        { label: 'United States (US)', value: 'US', code: 'US' },
        { label: 'Venezuela (VE)', value: 'VE', code: 'VE' },
        { label: 'Vietnam (VN)', value: 'VN', code: 'VN' },
        { label: 'Yemen (YE)', value: 'YE', code: 'YE' },
        { label: 'Zambia (ZM)', value: 'ZM', code: 'ZM' },
        { label: 'Zimbabwe (ZW)', value: 'ZW', code: 'ZW' }
    ]
};

export default ANALYTICS_FILTERS;